export interface AppUser {
  id: string;
  email: string;
  name: string;
  roles: Array<string>;
}

export interface AppUserWindows {
  id: string;
  email: string;
  name: string;
  roles: Array<string>;
}

export interface SignInRequest {
  id: string;
  password: string;
  persist: boolean;
}

export enum AuthorizationTypes {
  FORM = 'Form',
  WINDOWS = 'Windows',
}

export enum UserRoles {
  Admin = 'admin',
  EmailReports = 'emailReports',
  Planning = 'planning',
}
